import axios from "axios";
import { getBaseUrl } from "../../helpers";

export default axios.create({
  baseURL: getBaseUrl()
});
